export default function ActionDialog() {
  // TODO: react-native-dialog doesn't work in web, so we currently hide it
  // need to implement when we implement actions in playground
  return null;
}
